import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environments';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private readonly BASE_URL = 'baseUrl';
  private url: string;

  constructor(private httpClient: HttpClient) {
    this.url = environment.baseUrl;
  }

  getAnalytics() {
    return this.httpClient.get<any>(this.url + `v2/queries`);
  }

  deleteAnalytics(analyticsId: string) {
    return this.httpClient.delete<any>(this.url + `v2/queries/` + analyticsId);
  }

  viewAnalytics(analyticsId: string) {
    return this.httpClient.get<any>(this.url + `v2/queries/` + analyticsId);
  }
}
